"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const SUPPORTED_LOCALE_CODES = ['cs', 'da', 'de', 'en_GB', 'en', 'es', 'fr_CA', 'fr', 'it', 'ja', 'ko', 'nl', 'no', 'pl', 'pt_BR', 'sv', 'zh', 'zh_Hant'];
var _default = exports.default = SUPPORTED_LOCALE_CODES;